import { Component, OnInit } from '@angular/core';
import {KitFolderFormModel} from '../../services/kit-folder-form-model';
import {KitService} from '../../services/kit.service';
import {Kit} from '../../services/kit';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Router} from '@angular/router';
import {Folder} from '../../services/folder';
import {FolderService} from '../../services/folder.service';
import {ToasterService} from 'angular2-toaster';

@Component({
  selector: 'app-kit-folder-create',
  templateUrl: './kit-folder-create.component.html',
  styleUrls: ['./kit-folder-create.component.css']
})
export class KitFolderCreateComponent implements OnInit {

  public folder: KitFolderFormModel;
  public kitId: string;
  public kit: Kit;
  public sub: Subscription;

  constructor(private kitService: KitService,
              private folderService: FolderService,
              private route: ActivatedRoute,
              private router: Router,
              private toasterService: ToasterService
  ) {
    this.folder = new KitFolderFormModel();
  }

  ngOnInit() {
    this.sub = this.route
      .queryParams
      .subscribe(params => {
        this.kitId = params['kit'];
        this.kit = this.kitService.find(+this.kitId);
        if (!this.kit) {
          this.router.navigate(['dashboard', 'library']);
        }
      });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(event: any) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.folderService.createFolder(this.kit, this.folder.name).subscribe((folder: Folder) => {
      this.kitService.addFolderToKit(this.kit, folder);
      this.toasterService.pop('success', 'Success', 'Created folder');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/kit-folder-create/kit-folder-create.component.ts